class PaginationManager extends HTMLElement {
    constructor() {
      super();
      this.sectionID = this.querySelector('.blog-list').dataset.id;
      this.init();
    }
  
    init() {
      const infiniteScrollerEle = document.querySelector('[data-inifinite-trigger]');
      this._manageObserve(infiniteScrollerEle)
    }

    manageInifiniteScroll = (ele) => {
      var nextPageLink = ele.href;
      this.renderGridFromFetch(nextPageLink, 'pagination');
    }
  
    _manageObserve(button){
      if (button) {
         const observer = new IntersectionObserver( (entries) => {
            entries.forEach(entry => {
             if (entry.isIntersecting) {
                 this.manageInifiniteScroll(button);
               }
             });
            },{
              rootMargin: "0px",
              threshold: 0.01
            });
            observer.observe(button);
        }
    }

    _managePagination(event) {
      const _this = event.target.closest('[data-pagelinks]');
      if (!_this) return; 
      event.preventDefault();
      const nextPageLink = _this.href;
      this.renderGridFromFetch(nextPageLink, 'pagination');
    }
  
    renderGridFromFetch(url, type) {
      if (!url) return;
      url += `&sections=${this.sectionID}`;
      fetch(url)
        .then(response => response.json())
        .then((response) => {
          const gridHTML = response[this.sectionID];
          this.renderProductGrid(type, gridHTML);
        });
    }
  
    renderProductGrid(type, grid) {
      const blogParent = new DOMParser().parseFromString(grid, 'text/html');
      if (type === 'pagination') {
        const productGrids = document.querySelector('.blog-list');
        productGrids.insertAdjacentHTML('beforeend', blogParent.querySelector('.blog-list').innerHTML);
        const loadMoreBtn = document.getElementById('load-more');
        const newLoadMoreBtn = blogParent.getElementById('load-more');
        if (newLoadMoreBtn && loadMoreBtn) {
          loadMoreBtn.parentNode.replaceChild(newLoadMoreBtn, loadMoreBtn);
        } else if (loadMoreBtn) {
          loadMoreBtn.remove();
        }
         if (newLoadMoreBtn) {
             this._manageObserve(newLoadMoreBtn)
        }
      }
    }
  }

  customElements.define("pagination-manager", PaginationManager)